<template>
  <div id="wt-main">
    <transition mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  name: "wt-main",
  components: {},
  props: {},
  computed: {},
  methods: {}
};
</script>
